import { ImportWizardUploadMode } from '../../typings/importWizard';

export const CHANGE_IMPORT_MODE = 'CHANGE_IMPORT_MODE';
export type CHANGE_IMPORT_MODE = typeof CHANGE_IMPORT_MODE;

export interface ChangeImportMode {
    type: CHANGE_IMPORT_MODE;
    importMode: ImportWizardUploadMode;
}

export function changeImportModeAction(importMode: ImportWizardUploadMode): ChangeImportMode {
    return {
        type: CHANGE_IMPORT_MODE,
        importMode
    };
}
